var _defs, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _circle, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _rect, _rect2, _rect3, _circle2, _circle3, _circle4, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _g, _path143;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b759170a-51c3-4e2f-999d-77dec9fd6d11",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1140.56,
    height: 787.27,
    viewBox: "0 0 1140.56 787.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c518dc33-18b9-48bc-b516-0f83ad79191e",
    x1: 852.39,
    y1: 835.88,
    x2: 852.39,
    y2: 338.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maker launch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.48,470.82c20.16-32.93,65.75-27.19,98.08-10s64.59,42.85,100.17,37.92c30-4.16,54.6-30.32,67.89-60.5s17.19-64.21,20.93-97.54Q332.6,277.89,339.64,215c1.72-15.33,3.75-31.51,12.37-43.64,11.39-16,32.27-20.92,50.13-16.11s33.09,17.71,46.12,32.1C490,233.43,513.65,295.72,550.14,347c7.43,10.44,15.82,20.76,26.92,25.8,16,7.25,34.37,2.12,50-5.95,51-26.29,85.26-79.94,118.93-130,16.38-24.33,36.35-50.35,63.6-53C838.26,181,863.15,205.43,880,231.3c54.08,83.24,65.67,196.88,131,269.48,8.11,9,17.06,17.32,27.37,22.91a70.65,70.65,0,0,0,10.6,4.65c57,19.73,76,98.93,33.84,145.89-.91,1-1.84,2-2.78,3-6.26,6.61-13.35,12.86-21.81,14.83-7.87,1.82-16-.28-23.8-2.55-49.86-14.55-99.12-36.79-150.67-35.71-50.16,1-97.74,24.17-147.34,32.51-33.35,5.61-67.28,4.49-101,3.28q-168.46-6.06-336.85-14.1c-55.72-2.56-111.46-5-167.17-7.85-42.92-2.23-70.26-7.14-75.24-56.95C51.79,567.07,12.63,513.06,38.48,470.82Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 789.9,
    cy: 749.54,
    rx: 269.99,
    ry: 37.73,
    fill: "#30374e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.46,643.13s13.2-3,21.85,5.87c0,0-5.56,5-18.64-.54Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177,643s-7.82,11.08-2.86,22.45c0,0,6.76-3.25,6.57-17.45Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.2,626.3s4.69-10.15,27,2.12c0,0-2.4,6.78-11.88,6.88S171,631.29,168.2,626.3Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.78,625.68s-11.17-.52-10.54,24.92c0,0,7.13,1,11.58-7.38S169.91,630.51,166.78,625.68Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159,605.88S164,588.2,187.47,599c0,0-4.1,16.19-25.8,12.64Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29,580.54s10.58-18.24,32.49-3.44c0,0-6.19,16.87-30.29,9.55Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.15,556.14s12.63-16.95,34.36-2.31c0,0-12.06,14.94-34.09,6.4Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.41,532.42s12.76-17.66,33.59-3.15c0,0-14.68,15.83-33.33,7.07Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.23,511.16s13.15-22.53,32.65-9.17c0,0-14.42,19.57-32.37,13.26Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144,486.18S158,463.78,177.09,479c0,0-17.1,19.75-32.87,11.15Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.63,463.72s17-21.31,33.55-14.37c0,0-17.68,22.6-34,19.76Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.63,442.32s19.54-26,32.37-18.62c0,0-14.31,20.09-33.58,23.35Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.25,417.38s17.17-21.32,31-17.24c0,0-14.45,21.89-33.1,23.68Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M167.1,394.07s19.18-20.6,28.31-17.82c0,0-13.35,22.36-28.92,22.15Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M173.87,372.51s16.09-24.15,25.82-23c0,0-9.31,21.19-25.66,25.33Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M180.86,343.6s14.39-18.66,22.81-19.18c0,0-10.71,24.34-23.07,25Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.86,324.39l12.58-37.69s3,33.1-14,44.62Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188.25,283.53s.44-30.79-1.33-33.17c0,0,12.47,24.74,2.14,46.71Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M158.36,605.51s-16.26-8.62-24.77,15.73c0,0,14.5,8.28,27-9.81Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M149.72,579.59s-19.72-7.45-27.35,17.88c0,0,15.47,9.15,29.51-11.76Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.36,557.67S130.57,542.56,111,560c0,0,13.94,13.19,34.63,1.79Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M141.94,532.46s-15-15.81-33.71,1.36c0,0,16.66,13.73,34,2.55Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M142.27,511.76s-11.36-23.47-31.83-11.67c0,0,12.86,20.63,31.24,15.74Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M145.17,486s-11.33-23.9-32.06-11.07c0,0,14.66,21.61,31.34,14.93Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M149.7,463.7s-5.64-26.65-23.55-27.87c0,0,5.68,28.13,21.51,32.88Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M153.09,442.34s-3.67-32.31-18.46-32.46c0,0,2.15,24.57,17.11,37.15Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M161.72,416.35s-6.21-26.66-20.47-29c0,0,3.5,26,19.53,35.72Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M168.78,394.15s-2-28.07-10.9-31.62c0,0-3.61,25.78,8.65,35.38Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M174.51,372.16s-3.15-28.85-12.31-32.32c0,0-1.5,23.09,11.1,34.3Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M182.26,345.82s-1.64-23.51-8.35-28.61c0,0-4.58,26.19,5.35,33.56Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M184,323.28l-8.8-38.74s-6.23,32.64,9.57,45.78Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M182.63,284.28S165,259,165.14,256.06c0,0,3.54,27.48,24.41,39.89Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M184,276.39s-17.46-36.39-24.43-39c0,0,22.09,9.43,25.61,37.8Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M180.54,349.61l-1-.25c9.85-42,11.24-68.48,3.9-74.56l.68-.82C191.86,280.42,190.64,306.58,180.54,349.61Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#444053"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M152.26,448.27l-1.55-.43c1.09-3.86,2.27-7.79,3.53-11.66,11-33.72,20.14-65,25.75-88.94l1.27-.75c-5.62,24-14.51,56.43-25.49,90.18C154.52,440.53,153.34,444.43,152.26,448.27Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#444053"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M199.31,672.67c-.22-.21-22.22-21.87-39.12-60.24a232.37,232.37,0,0,1-18.61-70.77c-3-30.53,1.1-65.13,10-96.9l1.28,1.32c-20,71.31-6.19,130.34,9.23,165.4,16.73,38,38.48,59.45,38.7,59.66Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#444053"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M223.53,558.46s8-1.83,13.22,3.55c0,0-3.37,3-11.27-.33Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M222.66,558.39s-4.72,6.7-1.72,13.57c0,0,4.08-2,4-10.55Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M217.34,548.28s2.83-6.13,16.3,1.29c0,0-1.45,4.09-7.18,4.15S219.05,551.3,217.34,548.28Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M216.48,547.91s-6.76-.31-6.38,15.06c0,0,4.31.6,7-4.46S218.37,550.83,216.48,547.91Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M211.75,535.94s3.07-10.69,17.23-4.18c0,0-2.47,9.79-15.59,7.64Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M206.51,520.62s6.39-11,19.64-2.08c0,0-3.75,10.2-18.31,5.77Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M204,505.87s7.64-10.25,20.77-1.4c0,0-7.28,9-20.6,3.87Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M201.74,491.53s7.72-10.68,20.31-1.9c0,0-8.87,9.57-20.15,4.27Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M201.64,478.67s8-13.61,19.73-5.54c0,0-8.72,11.83-19.57,8Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M202.68,463.58s8.49-13.55,20-4.38c0,0-10.34,11.94-19.88,6.74Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M204.9,450s10.27-12.88,20.28-8.68c0,0-10.69,13.66-20.53,11.94Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M207.92,437.06s11.81-15.71,19.57-11.26c0,0-8.65,12.15-20.3,14.12Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M212.53,422s10.38-12.89,18.76-10.42c0,0-8.73,13.23-20,14.31Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M216.67,407.89s11.59-12.45,17.11-10.77c0,0-8.06,13.51-17.48,13.39Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M220.76,394.86s9.73-14.6,15.61-13.92c0,0-5.62,12.81-15.51,15.32Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M225,377.38s8.7-11.28,13.79-11.6c0,0-6.48,14.72-13.95,15.09Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M227.41,365.76,235,343s1.8,20-8.49,27Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M229.46,341.06s.26-18.61-.81-20.05c0,0,7.54,14.95,1.29,28.24Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M211.38,535.72s-9.82-5.22-15,9.5c0,0,8.77,5,16.33-5.92Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M206.17,520s-11.93-4.5-16.54,10.81c0,0,9.35,5.53,17.84-7.1Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M203.52,506.79s-8.93-9.13-20.77,1.4c0,0,8.43,8,20.94,1.08Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M201.46,491.55s-9.07-9.55-20.38.83c0,0,10.07,8.29,20.54,1.54Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M201.66,479s-6.87-14.19-19.25-7.06c0,0,7.78,12.47,18.89,9.52Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M203.41,463.45S196.56,449,184,456.76c0,0,8.86,13.07,18.95,9Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M206.15,450s-3.41-16.12-14.24-16.85c0,0,3.43,17,13,19.87Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M208.2,437.07S206,417.54,197,417.44c0,0,1.3,14.86,10.34,22.47Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M213.41,421.36s-3.75-16.12-12.37-17.54c0,0,2.12,15.71,11.81,21.59Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M217.68,407.94s-1.23-17-6.58-19.12c0,0-2.19,15.59,5.22,21.39Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M221.15,394.64s-1.9-17.44-7.44-19.54c0,0-.91,14,6.71,20.74Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M225.83,378.72s-1-14.21-5-17.3c0,0-2.77,15.84,3.23,20.29Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M226.91,365.09l-5.32-23.42s-3.77,19.74,5.78,27.68Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M226.06,341.52s-10.65-15.27-10.57-17.06c0,0,2.13,16.61,14.75,24.11Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M226.86,336.74s-10.56-22-14.77-23.55c0,0,13.36,5.7,15.48,22.86Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M224.79,381l-.63-.15c6-25.39,6.8-41.4,2.36-45.07l.41-.5C231.64,339.18,230.9,355,224.79,381Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#444053"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M207.7,440.66l-.94-.27c.66-2.33,1.38-4.7,2.14-7,6.63-20.39,12.17-39.3,15.56-53.77l.77-.46c-3.4,14.5-8.77,34.12-15.41,54.53C209.06,436,208.35,438.33,207.7,440.66Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#444053"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M236.14,576.32c-.13-.13-13.43-13.22-23.65-36.42a140.72,140.72,0,0,1-11.25-42.78c-1.83-18.46.67-39.38,6.06-58.59l.77.8c-12.09,43.11-3.74,78.8,5.58,100,10.12,23,23.26,35.93,23.4,36.06Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#444053"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M266.22,626.32a38.24,38.24,0,0,0-7.5,2.14C204.78,650,205.68,791,205.68,791H189.8s-5-60.51-26.79-146.84c-19.63-77.67,60.88-147.28,77.23-160.48,1.84-1.47,2.86-2.25,2.86-2.25C324.19,511.23,266.22,626.32,266.22,626.32Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#afc0e0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M249,483.88c-1.87-.86-3.8-1.68-5.85-2.43,0,0-1,.78-2.86,2.25-16.35,13.2-96.86,82.81-77.23,160.48C184.85,730.51,189.8,791,189.8,791h8.93s-4.95-60.51-26.79-146.84C152.39,566.85,232.12,497.5,249,483.88Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fff",
    opacity: 0.2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M533.76,644.18C511.92,730.51,507,791,507,791H491.09s1-147.36-56.73-163.81a31.53,31.53,0,0,0-3.81-.89s-58-115.09,23.12-144.87c0,0,.82.61,2.3,1.8C471,495.26,553.61,565.61,533.76,644.18Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#afc0e0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M266.22,626.32a38.24,38.24,0,0,0-7.5,2.14A979.21,979.21,0,0,1,240.24,483.7c1.84-1.47,2.86-2.25,2.86-2.25C324.19,511.23,266.22,626.32,266.22,626.32Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M456,483.25a901,901,0,0,1-21.61,144,31.53,31.53,0,0,0-3.81-.89s-58-115.09,23.12-144.87C453.67,481.45,454.49,482.06,456,483.25Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M426.31,648.14q-8.4,33.14-19.69,68s-35.72,37.21-122,0c0,0-8.62-24.3-18.1-65.61-20.87-90.83-45.9-263.92,7.43-441.71A661.75,661.75,0,0,1,341.13,56.36s45.56,52.31,79,152.43S474.85,456.86,426.31,648.14Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#e3e8f4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 318.66,
    cy: 293.6,
    r: 71.63,
    fill: "#afc0e0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M399.18,350a50.8,50.8,0,0,1-83,39.29,51.33,51.33,0,0,1-9.52-10.33,50,50,0,0,1-3.28-5.39A50.7,50.7,0,0,1,297.59,350c0-.41,0-.81,0-1.21a50.86,50.86,0,0,1,37-47.72,52.53,52.53,0,0,1,12.24-1.86h1.52A50.8,50.8,0,0,1,399.18,350Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M420.12,208.79c-81.27,38.91-146.22,0-146.22,0A661.75,661.75,0,0,1,341.13,56.36S386.69,108.67,420.12,208.79Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#afc0e0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M426.31,648.14q-5.7,22.44-12.7,45.65-3.32,11.07-7,22.32s-35.72,37.21-122,0c0,0-2.8-7.89-7-22.32-3.14-10.9-7.05-25.51-11.13-43.29,0,0,32.12,13.71,77.71,13.71A214.11,214.11,0,0,0,426.31,648.14Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#afc0e0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M413.61,693.79q-3.32,11.07-7,22.32s-35.72,37.21-122,0c0,0-2.8-7.89-7-22.32C277.6,693.79,365.54,719.09,413.61,693.79Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#e3e8f4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M334.62,301l-.11.08-36.9,47.64c0,.4,0,.8,0,1.21a50.7,50.7,0,0,0,5.79,23.57l43.48-74.36Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fff",
    opacity: 0.2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M346.4,344l-30.22,45.25a51.33,51.33,0,0,1-9.52-10.33l36-38.64Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fff",
    opacity: 0.2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M303.92,716.12s-8.62-24.31-18.1-65.61c-20.87-90.84-45.9-263.93,7.43-441.72A664.18,664.18,0,0,1,352.1,70.7c-6.77-9.49-11-14.33-11-14.33A661.68,661.68,0,0,0,273.9,208.79c-53.33,177.79-28.3,350.88-7.43,441.72,9.48,41.3,18.1,65.61,18.1,65.61,34.09,14.69,60.28,17.77,79.5,16.13C347.65,731,327.71,726.37,303.92,716.12Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fff",
    opacity: 0.2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M966.7,785.29s46.74-58.16,43.64-116.41a113.05,113.05,0,0,1,18.54-69.06,190.19,190.19,0,0,1,22-27",
    transform: "translate(-29.72 -56.36)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.11,536.14c-3.34,8.11,1.66,37.68,1.66,37.68s24.37-17.48,27.71-25.59a15.88,15.88,0,0,0-29.37-12.09Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.33,571.08c1.61,8.62,21.88,30.72,21.88,30.72s11-27.91,9.35-36.54a15.88,15.88,0,0,0-31.23,5.82Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M975.79,648.3c5.74,6.63,34.4,15.48,34.4,15.48s-4.64-29.63-10.38-36.27a15.88,15.88,0,0,0-24,20.79Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M965.84,711.93c4.53,7.51,31.28,21.07,31.28,21.07s.44-30-4.09-37.5a15.88,15.88,0,1,0-27.19,16.43Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.4,616.07c-8.14,3.25-37.66-2.05-37.66-2.05s17.72-24.19,25.87-27.45a15.88,15.88,0,0,1,11.79,29.5Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.82,690.34c-8.74.67-35.32-13.22-35.32-13.22s24.14-17.79,32.89-18.46a15.89,15.89,0,0,1,2.43,31.68Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.69,760.84c-8.51,2.14-37.05-7.06-37.05-7.06s20.79-21.61,29.3-23.74a15.88,15.88,0,1,1,7.75,30.8Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.11,536.14c-3.34,8.11,1.66,37.68,1.66,37.68s24.37-17.48,27.71-25.59a15.88,15.88,0,0,0-29.37-12.09Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.25
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.33,571.08c1.61,8.62,21.88,30.72,21.88,30.72s11-27.91,9.35-36.54a15.88,15.88,0,0,0-31.23,5.82Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.25
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M975.79,648.3c5.74,6.63,34.4,15.48,34.4,15.48s-4.64-29.63-10.38-36.27a15.88,15.88,0,0,0-24,20.79Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.25
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M965.84,711.93c4.53,7.51,31.28,21.07,31.28,21.07s.44-30-4.09-37.5a15.88,15.88,0,1,0-27.19,16.43Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.25
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.4,616.07c-8.14,3.25-37.66-2.05-37.66-2.05s17.72-24.19,25.87-27.45a15.88,15.88,0,0,1,11.79,29.5Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.25
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.82,690.34c-8.74.67-35.32-13.22-35.32-13.22s24.14-17.79,32.89-18.46a15.89,15.89,0,0,1,2.43,31.68Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.25
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.69,760.84c-8.51,2.14-37.05-7.06-37.05-7.06s20.79-21.61,29.3-23.74a15.88,15.88,0,1,1,7.75,30.8Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.25
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M967.12,782.86s66.3-34.24,87.07-88.74a113,113,0,0,1,44.94-55.63,189.91,189.91,0,0,1,31-15.76",
    transform: "translate(-29.72 -56.36)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.42,588.46c-6.34,6.07-13.75,35.13-13.75,35.13s29.36-6.11,35.7-12.17a15.88,15.88,0,0,0-21.95-23Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.16,603.07c-2,8.54,7.55,37,7.55,37S1119,619,1121.06,610.41a15.88,15.88,0,0,0-30.9-7.34Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.94,661.29c2.56,8.39,25.18,28.09,25.18,28.09s7.77-29,5.21-37.35a15.88,15.88,0,0,0-30.39,9.26Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M996.06,715.43c1.1,8.71,20.06,31.94,20.06,31.94s12.56-27.23,11.45-35.94a15.88,15.88,0,0,0-31.51,4Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.53,665.3c-8.77-.32-33.6-17.13-33.6-17.13s26-14.93,34.77-14.61a15.88,15.88,0,1,1-1.17,31.74Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.93,728.1c-8.27-2.93-26.94-26.4-26.94-26.4s29.29-6.47,37.55-3.54a15.88,15.88,0,1,1-10.61,29.94Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.12,783.59c-8.64-1.49-31-21.47-31-21.47s27.77-11.32,36.41-9.83a15.88,15.88,0,1,1-5.4,31.3Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#fbe1e5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.39,750.72,1010,676.19s-1-18.45-4.32-22.76-.72-13.9-.72-13.9,3.6-5.27.48-5.75-.48-12.23-.48-12.23l-.24-18.69s2.88-18,.48-22.28a7.07,7.07,0,0,1,.24-7.67s2.88-10.31,0-12.94-2.16-18.7-1.44-31.4-5.05-19.89-5.05-21.81-19-20.61-19-22.28-12-8.63-19.21-10.55-10.81-3.35-10.57-4.31-11.29-4.79-11.29-4.79-10.09-.72-13.94-5.76-15.59-6.48-15.93-6.53c-.07-.33-.15-.67-.22-1s-.15-.72-.22-1.08c.91-1.53,1.75-3.09,2.51-4.7.23-.49.45-1,.66-1.46,4.21-.19,8.53-1.09,11.83-3.67a16.11,16.11,0,0,0,5.75-11.49,25.19,25.19,0,0,0-2.81-12.77c-2.1-4.32-5.19-8.79-4.13-13.47.47-2,1.68-3.8,2.3-5.78,1.17-3.75.09-7.87-1.73-11.35s-4.35-6.54-6.37-9.91a38.7,38.7,0,0,1-5.07-14c-.41-2.6-.57-5.34-1.88-7.63a14.21,14.21,0,0,0-4.21-4.25,42.07,42.07,0,0,0-25.82-7.83c-6.54.23-13.06,2-19.55,1.19-3.91-.48-7.64-1.87-11.42-3-8.06-2.38-17.35-3.36-24.37,1.25s-9.81,13.68-14.56,20.77c-4.2,6.28-10.36,11.54-13.56,18.18,0-.12.06-.25.1-.38a21.75,21.75,0,0,0-1.79,4.84c-1.22,5.22-.2,10.68,1.07,15.89.65,2.69,1.55,5.61,3.88,7.1s5.63,1.16,8.39,1.65c-.1.45-.22.91-.32,1.37a54.9,54.9,0,0,0,38.09,64c0,.49,0,1,0,1.46a36.33,36.33,0,0,1-.25,4.12h0s-24.15-5-30.64-1.6-19.22,6-21.14,7.9-6.72.48-11,11.75-4.8,22.76-10.33,28-8.4,8.87-8.64,12.71.72,4.79-1.45,6-5.28,6.23-4.32,8.15c0,0,1.2,4.79-2.64,7.18s-3.37,7.19-3.37,7.19-1.44,5.28-4.8,6.47-5.53,9.11-5.53,9.11L730.52,596,708.93,572.1a9.1,9.1,0,0,0-12.85-.66L685.48,581a20.94,20.94,0,0,0-10.61,6.32,27.35,27.35,0,0,0-5.49,8.18l-5.81,5.22A14.75,14.75,0,0,0,662.08,617l13.83,15.29.09.13c-5.23.66-9.85,2.34-13.38,5.45-20.65,18.21-20.9,35-17.77,42.65s29.3,37.15,29.3,37.15,15.21,19.77,37.17,30.29l0,0-.17.17c-.43.46-.86,1-1.28,1.5l-.36.46-.33.46-.39.58c-.11.15-.21.31-.31.47s-.28.45-.41.69l-.27.46c-.16.3-.33.61-.49.93l-.16.31c-.2.42-.4.85-.59,1.3-.07.16-.13.33-.2.49-.12.31-.25.63-.37,1s-.15.41-.22.62-.21.62-.31.94-.14.45-.2.67-.2.7-.29,1.06-.11.42-.17.65c-.13.55-.26,1.12-.37,1.72,0,.22-.08.45-.12.68q-.12.6-.21,1.23c-.05.29-.08.58-.12.87s-.1.79-.15,1.19l-.09.92c0,.44-.08.9-.11,1.36,0,.28,0,.56-.05.84,0,.76-.08,1.52-.09,2.32-.48,28,1.16,32.11,1.16,32.11s3.39,8.93,12.75,9.57a16.3,16.3,0,0,0,4.11-.22c12.49-2.16,41.79-7.19,52.12-5.27,6.21,1.15,17.71-.55,25.9-2.1l2.15-.41,1.5,4.76,4.75-1.3,4,2.33,2.55,1.46c4.74,16.08,24,10.6,24,10.6L843,826l46.36,1.2s10,6,16.41,7.88a15.24,15.24,0,0,0,2.33.51,105.21,105.21,0,0,0,12.92.24c3.55-.09,6.3-.24,6.3-.24s-.47-12.59-1.15-26.68c17.72-.74,33.43-1.85,42.94-3.52,24.76-4.35,35.09-26.86,38.89-38.89a113.19,113.19,0,0,1,2.43,14.93,106.74,106.74,0,0,0,3.85,12.94,43.73,43.73,0,0,0,5.28,9.58c18.26-6.23,7.21-15.57,3.36-19.65s2.65-7.43,2.65-7.43,5-3.35,4.56-6.47-.72-6.47,15.61-6.23S1061.39,750.72,1061.39,750.72Zm-253.66-153c.21,1.37,2.49,16.14,4.55,20,.43.82.6,3.73.54,7.89-9.68-.77-19.76-1.18-19.76-1.18a2.32,2.32,0,0,1,.52,1.23l-1.52-.34-2.21-.54,17.83-27.12Zm-35.32,56.2,16.75,2.66,1.41.22a55.11,55.11,0,0,0-.87,7.91c0,.25.38.55.92.9a21.57,21.57,0,0,0-.33,4c.27,1.33,8.1,4.19,17.08,6.57-.12.48-.24.94-.36,1.37h0c-7.93-4.17-20.43-6.12-21.87-9.22s-44-18-44-18-1.55-.82-4.23-2.12l11.2,2.12,3.08-.31A167.91,167.91,0,0,0,772.41,653.9Z",
    transform: "translate(-29.72 -56.36)",
    fill: "url(#c518dc33-18b9-48bc-b516-0f83ad79191e)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.71,761.15s-6.66,40.23-40.47,46.18-146.66,4.76-146.66,4.76-64.52-9.28-87.85-63.8S693.4,672.1,713.4,671.15s127.85,36.43,134,36.9S1012.66,625.2,1006.71,761.15Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#434175"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.71,761.15s-6.66,40.23-40.47,46.18-146.66,4.76-146.66,4.76-64.52-9.28-87.85-63.8S693.4,672.1,713.4,671.15s127.85,36.43,134,36.9S1012.66,625.2,1006.71,761.15Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.05
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M704.07,805.9s3.37,8.88,12.64,9.51a16.43,16.43,0,0,0,4.07-.22c12.38-2.14,41.43-7.14,51.66-5.24,6.16,1.15,17.55-.55,25.66-2.08,5.4-1,9.34-2,9.34-2s-9.52-31.66-10.72-32.61-42.85-25.95-42.85-25.95l-33-2.37h-.1s-6.11.41-11.18,6.57c-3.49,4.21-6.48,11.13-6.68,22.47C702.45,801.85,704.07,805.9,704.07,805.9Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#565387"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M704.07,805.9s3.37,8.88,12.64,9.51a135.54,135.54,0,0,1-9-13.08l.17-23.09c-1.47-17.29,6.62-28.36,13-34.27h-.1s-17.38,1.18-17.86,29S704.07,805.9,704.07,805.9Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.05
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M847.2,755.43l30.71-24,48.33-47.62s-5.22-.25-13.09-.59c-2,1.25-7.45,5.18-7.65,10-.24,5.82-13.07.4-19.73,3.73s-39.28,45.08-45,44.81-10.23-2.9-12.62,1.15c0,.09-.11.17-.17.26Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M709.6,751.53c1.09.53,2.19,1,3.32,1.52,23.34,10,52.14,31,54.29,34.76,1.3,2.32,18,12.46,30.89,20.06,5.4-1,9.34-2,9.34-2s-9.52-31.66-10.72-32.61-42.85-25.95-42.85-25.95l-33-2.37h-.1S714.67,745.37,709.6,751.53Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M644.84,683.29c3.09,7.62,29,36.91,29,36.91s16.42,21.42,39.76,31.42,52.14,31,54.28,34.76c1.38,2.45,20,13.65,33.08,21.35l2.93,1.71,6.5,3.77,3.44,2s8-6.4,15.91-12.84,15.63-12.75,15.76-13.11c.23-.71,3.32-8.81,2.61-9.28-.37-.25-2-3.55-5-7.37a33.82,33.82,0,0,0-12.13-10c-11-5-15.71-16.38-15.71-16.38s-1-.76-2.63-1.76c-2.82-1.78-7.35-4.34-10.7-4.77-5.25-.66-15-11.37-15-11.37s-6.67-4.29-9.29-9.76c-2.5-5.22-39.42-30.58-42.84-32.92l89.51,57.48,21.42,13.77,30.71-24,48.34-47.62s-6.5-.32-16-.72c-23.49-1-65.21-2.61-70.48-1.42a40.17,40.17,0,0,1-13.1.85s-11.88.54-19.74-3.61-20.25-6.09-21.68-9.16-43.57-17.85-43.57-17.85-57.37-30.47-77.85-12.37S641.74,675.68,644.84,683.29Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#434175"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M829.82,508.55l7.38,24.52,9.52,55.23,35,2.38,10.13-16.8L902,557.11s6.3-22.32,10.83-43.91c4-19.1,6.62-37.64,2.26-39.65-3.86-1.79-6.4-8.22-8-15.14-.21-.85-.4-1.72-.58-2.59a134.62,134.62,0,0,1-2.32-17.75s-73.33-3.8-63.09,26.43a48.18,48.18,0,0,1,2.76,16.08,38.23,38.23,0,0,1-.25,4.09A34.3,34.3,0,0,1,829.82,508.55Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#ee8e9e"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M814.58,504.5l2.62,41.66,5.95,35.47,6.67,16.43,5.95,89.88s57.41,6.64,71.37-.12a6.14,6.14,0,0,0,2.53-2C926.53,660.39,921,586.63,921,586.63L927.43,539l-4.29-24.72-10.35-1.1-8-.85s-1.8,2.22-4.4,5.65c-7.06,9.32-20,27.65-19.17,35.3,1.18,10.48-1.43,21.19-5.48,22.86s-7.38,4.52-8.09,1.67-1.43-3.57-.72-7.62-3.1-16.43-3.1-16.43-6.42-14.52-6-20.71-.71-13.34-2.62-15-4.52-3.34-2.38-11-9.39-22.45-9.39-22.45Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#e3e8f4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M890.41,608.55l2.38,71.19,13.75,7.62a6.15,6.15,0,0,0,2.53-2c16.87-25.47,11.34-99.22,11.34-99.22l6.43-47.62-4.29-24.71-10.36-1.1c4-19.1,6.62-37.64,2.27-39.65-3.87-1.79-6.41-8.22-8.06-15.14h0L899,508.32s.62,4.54.84,9.22c.17,3.48.11,7-.6,8.87-1.67,4.29-.48,11.91-.48,11.91-4.29,7.56-6.43,21.57-7.48,35.1C889.87,591.41,890.41,608.55,890.41,608.55Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M906.63,456.82s12,1.49,15.8,6.49S936.24,469,936.24,469s11.43,3.81,11.19,4.76,3.33,2.39,10.48,4.29,19,8.81,19,10.48,18.81,20.23,18.81,22.14,5.72,9,5,21.66-1.43,28.57,1.43,31.19,0,12.86,0,12.86A7,7,0,0,0,1002,584c2.38,4.29-.47,22.15-.47,22.15l.23,18.57s-2.62,11.66.48,12.14-.48,5.71-.48,5.71-2.62,9.53.72,13.81,4.28,22.62,4.28,22.62l51,74s.72,13.57-15.47,13.33-16,3.1-15.48,6.19-4.52,6.43-4.52,6.43-6.43,3.33-2.62,7.38,14.76,13.33-3.33,19.52a43.16,43.16,0,0,1-5.24-9.52,107.72,107.72,0,0,1-3.81-12.85s-1.67-18.1-5-20.48-2.86-13.81-2.86-13.81,4.76-9.28-1.9-13.09S894.1,678.77,894.1,678.77l-2.38-71.19s-1.67-52.61,8.33-70.23c0,0-1.19-7.62.48-11.9s-.24-18.1-.24-18.1Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#565387"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M844.23,485.38s-23.93-4.93-30.36-1.6-19,6-21,7.86-6.67.48-10.95,11.67-4.77,22.61-10.24,27.85-8.33,8.81-8.57,12.62.71,4.76-1.43,6-5.24,6.19-4.29,8.1S807,601.63,807,601.63s2.39,16,4.53,20-2.38,59.76-7.14,63.57,32.14,3.46,32.14,3.46,1.66-36.55,3.09-38.46-1-41-1-41-.24-33.33,2.86-42.14S844.23,529,844.23,529s2.74-17.57,6.07-21.67S844.23,485.38,844.23,485.38Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M843.52,484.67s-23.94-4.93-30.37-1.6-19,5.95-20.95,7.86-6.66.47-11,11.66-4.76,22.62-10.24,27.86-8.33,8.81-8.57,12.62.72,4.76-1.42,5.95-5.24,6.19-4.29,8.09,49.52,43.81,49.52,43.81,2.38,16,4.52,20-2.38,59.75-7.14,63.56,32.14,3.46,32.14,3.46,1.67-36.55,3.1-38.45-1-41-1-41-.23-33.33,2.86-42.14,2.75-38.1,2.75-38.1,2.74-17.57,6.06-21.66S843.52,484.67,843.52,484.67Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#565387"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M841,464.5a48.18,48.18,0,0,1,2.76,16.08,54.63,54.63,0,0,0,62.65-24.76,134.62,134.62,0,0,1-2.32-17.75S830.77,434.27,841,464.5Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M804.82,426.88A54.52,54.52,0,1,0,806,415.55,54.53,54.53,0,0,0,804.82,426.88Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#ee8e9e"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M769.82,553.06l-13.09,4.05s1.19,4.76-2.62,7.14-3.33,7.15-3.33,7.15-1.43,5.23-4.76,6.42-5.48,9-5.48,9l-10.95,12.62s-4.05,3.33-3.33,5-4.29,2.14-4.29,2.14L724.59,649l22.62,4.29,14-1.43,11.43-4.29,10-6L787.2,630l20-30.47Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#565387"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M725.3,610s-29-41.91-50.71-19.29,8.81,59.28,15.95,58.09,41.19-3.09,41.19-3.09Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#ee8e9e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 671.34,
    y: 583.93,
    width: 61.42,
    height: 69.8,
    rx: 12.62,
    ry: 12.62,
    transform: "translate(-263.46 573.17) rotate(-42.05)",
    fill: "#30374e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 671.34,
    y: 583.93,
    width: 61.42,
    height: 69.8,
    rx: 12.62,
    ry: 12.62,
    transform: "translate(-263.46 573.17) rotate(-42.05)",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 672.16,
    y: 580.48,
    width: 61.42,
    height: 69.8,
    rx: 12.62,
    ry: 12.62,
    transform: "translate(-260.94 572.83) rotate(-42.05)",
    fill: "#30374e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 672.39,
    cy: 560.74,
    r: 13.57,
    fill: "#fbe1e5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 672.39,
    cy: 560.74,
    r: 13.57,
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 673.15,
    cy: 559.02,
    r: 13.57,
    fill: "#fbe1e5"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M706.5,618.77c-.24,31.43,64.76,38.09,64.76,38.09l16.6,2.64,7.44,1.18L798.4,630s-3.41-.51-7.67-1.5c-6.29-1.47-14.44-4-16.15-7.55C771.73,615,706.73,587.35,706.5,618.77Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#ee8e9e"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M806,415.55a6.47,6.47,0,0,1,4,1.78c1.84,1.95,1.94,5.41,4.33,6.61a4.92,4.92,0,0,0,2.84.33c6.33-.9,10-8,16.07-10,3.46-1.12,7.27-.39,10.65.91a7.93,7.93,0,0,1,3.53,2.27c2,2.63.61,6.5,1.55,9.69,1.31,4.42,6.59,6.18,11.16,6.76s9.72.9,12.77,4.35c2.16,2.45,2.71,6,2.27,9.21a7.29,7.29,0,0,0,0,3.41c1.26,3.57,7.44,3,9.05.22,1.18-2.05.82-3.75,3.6-4.32,1.88-.39,4.09.4,5.83,1a42.71,42.71,0,0,0,15.08,2.32A54.53,54.53,0,1,0,806,415.55Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M875.14,449.43a7.29,7.29,0,0,1,0-3.41c.43-3.23-.11-6.77-2.27-9.21-3-3.45-8.2-3.78-12.77-4.35s-9.85-2.33-11.16-6.75c-.94-3.19.48-7.07-1.55-9.7a7.8,7.8,0,0,0-3.52-2.26c-3.39-1.31-7.2-2-10.66-.92-6.07,2-9.74,9.12-16.07,10a4.92,4.92,0,0,1-2.84-.33c-2.39-1.2-2.49-4.66-4.33-6.6-2.89-3.06-8.38-1.09-11.92-3.36-2.31-1.49-3.2-4.38-3.84-7.05-1.26-5.18-2.27-10.61-1.06-15.79,2.07-8.86,10-14.93,15-22.49,4.71-7.05,7.35-16,14.43-20.64s16.17-3.61,24.15-1.24c3.74,1.11,7.44,2.49,11.31,3,6.44.79,12.9-1,19.38-1.18a41.62,41.62,0,0,1,25.59,7.77,14.16,14.16,0,0,1,4.18,4.23c1.29,2.28,1.46,5,1.85,7.58a38.75,38.75,0,0,0,5,13.93c2,3.35,4.51,6.39,6.32,9.85s2.87,7.55,1.71,11.27c-.61,2-1.82,3.73-2.27,5.74-1.06,4.65,2,9.09,4.09,13.38a25.1,25.1,0,0,1,2.78,12.69,16,16,0,0,1-5.7,11.41c-3.37,2.64-7.8,3.52-12.07,3.66a42.78,42.78,0,0,1-15.38-2.31c-1.75-.6-4-1.39-5.83-1-2.78.57-2.42,2.27-3.6,4.32C882.57,452.47,876.4,453,875.14,449.43Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#434175"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M845.77,756.86l30.71-24,48.34-47.62s-6.5-.32-16-.72c-1.73,1.76-3.27,4-3.37,6.5-.24,5.82-13.07.41-19.73,3.74s-39.28,45.07-45,44.8-10.23-2.9-12.62,1.15a2.46,2.46,0,0,1-.17.27,6.77,6.77,0,0,1-3.63,2.15Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M783.87,755.19l15.43,49.26,2.42,7.74,7.35-2,16.2-4.45,72.16-19.82s13.56-.18,26-6.93c13.75-7.48,29.26-11.24,44.84-9.78,9.54.89,20.15-3.22,29-19.48,0,0,20-59-30.48-76s-52.88,9-52.88,9-.26.14-.68.42c-2,1.25-7.45,5.18-7.65,10-.24,5.82-13.07.4-19.73,3.73s-39.28,45.08-45,44.81-10.23-2.9-12.62,1.15c0,.09-.11.17-.17.26-1.76,2.43-7.06,3-10.57,3.09-1.91.06-3.3,0-3.3,0l-.45.14L810,747.37Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#434175"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M787.86,659.5l7.44,1.18L798.4,630s-3.41-.51-7.67-1.5C791.86,632.75,789.3,649.32,787.86,659.5Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M982.54,516s22.14-6.43,16.66,56.43S952.78,675,952.78,675s-47.14,20.71-68.33,17.38-36.66-4-36.66-4a53.79,53.79,0,0,0-21.43-5.71c-11.91-.48-36.9-7.86-37.38-10.24s6.19-37.38,3.33-40c0,0,33.33,1.37,36.67,3.78s8.09.68,11.66,0,14.53-10.21,36.19-1.87c0,0,7.38.71,10.24-1.19s7.44-.48,7.44-.48S899,631,899.69,630s6.42,0,6.42,0a2.54,2.54,0,0,0,3.58-1.67,15.56,15.56,0,0,1,3.33-5.23s6.43-36.19,18.57-49.76c0,0,3.57-3.1,2.62-6.91S954,508.37,982.54,516Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M982,511.16s22.14-6.43,16.67,56.43S952.19,670.2,952.19,670.2s-47.14,20.71-68.33,17.38-36.66-4.05-36.66-4.05a53.72,53.72,0,0,0-21.43-5.71c-11.9-.48-36.9-7.86-37.38-10.24s6.19-37.38,3.34-40c0,0,33.33,1.37,36.66,3.78s8.1.68,11.67,0,14.52-10.2,36.19-1.87c0,0,7.38.71,10.23-1.19s7.45-.48,7.45-.48,4.46-1.67,5.17-2.62,6.43,0,6.43,0a2.53,2.53,0,0,0,3.57-1.66,15.54,15.54,0,0,1,3.33-5.24s6.43-36.19,18.57-49.76c0,0,3.57-3.1,2.62-6.9S953.38,503.54,982,511.16Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#565387"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M810,747.37l31.44,38c.12-.11.2-.19.2-.22.24-.72,3.33-8.81,2.62-9.29s-6.19-12.38-17.14-17.38c-6.69-3-11.07-8.49-13.46-12.25Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M810.43,813.21l3.44,2s8-6.4,15.91-12.84,15.63-12.75,15.76-13.11c.23-.71,3.32-8.81,2.61-9.28-.37-.25-2-3.55-5-7.37-21.32-6-7.75,8.83-5.94,9.51,0,0-26-6-27.38,22.31A33.36,33.36,0,0,0,810.43,813.21Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M836.72,825.19l4.53,2.62,46,1.19s9.86,6,16.26,7.82a13.93,13.93,0,0,0,2.31.51,103.27,103.27,0,0,0,12.8.24c3.52-.09,6.25-.24,6.25-.24s-2.18-58-3.82-64c-.78-2.92-4.63-2.28-8.43-.82a55.19,55.19,0,0,0-8.23,4.17s-19.52,1.89-22.62,3.57-11.9-1-17.38,0-15.23-6.45-15.23-6.45c-26.67-8.8-11.67,7.62-9.77,8.34,0,0-25.94-6-27.37,22.31S836.72,825.19,836.72,825.19Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#565387"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M903.15,802.81c.5,12,9.85,26.89,15.42,34.76,3.52-.09,6.25-.24,6.25-.24s-2.18-58-3.82-64c-.78-2.92-4.63-2.28-8.43-.82C908,781.11,902.75,793.14,903.15,802.81Z",
    transform: "translate(-29.72 -56.36)",
    fill: "#565387"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M903.15,802.81c.5,12,9.85,26.89,15.42,34.76,3.52-.09,6.25-.24,6.25-.24s-2.18-58-3.82-64c-.78-2.92-4.63-2.28-8.43-.82C908,781.11,902.75,793.14,903.15,802.81Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M895.29,804.4c3.16,11.58,3.13,24.57,8.17,32.42a13.93,13.93,0,0,0,2.31.51,103.27,103.27,0,0,0,12.8.24c3.52-.09,6.25-.24,6.25-.24s-2.18-58-3.82-64c-.78-2.92-4.63-2.28-8.43-.82a55.19,55.19,0,0,0-8.23,4.17S891.25,789.58,895.29,804.4Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.05
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M736.77,686.94s22.82,7.41,42.16,33.73Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.23,401.26a4.67,4.67,0,0,1-.14.5,16.15,16.15,0,0,1-.79,2A14.93,14.93,0,0,1,922.23,401.26Z",
    transform: "translate(-29.72 -56.36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.11,389.71a21.46,21.46,0,0,1,1.77-4.81c-.12.41-.25.82-.35,1.24-1.21,5.18-.2,10.61,1.06,15.79.65,2.67,1.53,5.56,3.84,7.05,3.55,2.27,9,.29,11.92,3.35,1.84,1.95,1.94,5.41,4.34,6.61a4.91,4.91,0,0,0,2.84.33c6.32-.9,10-8,16.07-10,3.46-1.12,7.26-.39,10.65.92a7.8,7.8,0,0,1,3.52,2.26c2,2.63.61,6.51,1.55,9.69,1.31,4.42,6.59,6.18,11.16,6.75s9.72.9,12.77,4.36c2.16,2.44,2.71,6,2.27,9.21a7.42,7.42,0,0,0,0,3.41c1.26,3.57,7.44,3,9,.22,1.18-2.05.83-3.75,3.61-4.32,1.87-.39,4.08.4,5.82,1a42.78,42.78,0,0,0,15.38,2.31c4.27-.15,8.71-1,12.07-3.66a14,14,0,0,0,3.7-4.5A15.14,15.14,0,0,1,921,445c-3.36,2.64-7.79,3.52-12.07,3.66a42.69,42.69,0,0,1-15.37-2.31c-1.75-.6-4-1.39-5.83-1-2.78.57-2.43,2.27-3.6,4.32-1.62,2.82-7.79,3.35-9.06-.22a7.42,7.42,0,0,1,0-3.41c.44-3.23-.1-6.77-2.26-9.21-3.06-3.45-8.21-3.78-12.78-4.35s-9.85-2.33-11.15-6.75c-.95-3.19.48-7.07-1.55-9.7a7.88,7.88,0,0,0-3.53-2.26c-3.39-1.31-7.19-2-10.65-.92-6.08,2-9.75,9.12-16.07,10a4.91,4.91,0,0,1-2.84-.33c-2.4-1.2-2.5-4.66-4.34-6.6-2.89-3.06-8.37-1.09-11.91-3.36-2.32-1.49-3.2-4.38-3.85-7.05C792.9,400.32,791.89,394.89,793.11,389.71Z",
    transform: "translate(-29.72 -56.36)"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M925.92,580.26c-4.36,5.89-9.34,11.34-13.2,17.57s-6.59,13.5-5.78,20.78c4-4.1,5.82-9.76,8.34-14.9,4.26-8.7,10.64-16.08,16-24.08,1-1.53,7.61-10.35,4.28-10.77C932.82,568.51,927.41,578.25,925.92,580.26Z",
    transform: "translate(-29.72 -56.36)",
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.7e842c00645ce9f34dea8600cf6b5633.svg";
export { ForwardRef as ReactComponent };